export const SERVICES_BOOKINGS_REQUEST_V2 = 'servicesBookingsRequestsV2';
export const SERVICES_CALENDARS_REQUESTS_V2 = 'servicesCalendarsRequestsV2';
export const SERVICES_ATLAS_REQUESTS = 'servicesAtlasRequests';
export const SERVICE_OFFER_BOOKINGS_REQUEST_V2 =
    'servicesOfferBookingsRequestsV2';
export const SERVICES_ATLAS_REQUESTS_V2 = 'servicesAtlasRequestsV2';
export const SERVICE_OFFER_BOOKINGS_REQUEST_V3 =
    'servicesOfferBookingsRequestsV3';
